"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetVouchersCount200ResponseToJSON = exports.GetVouchersCount200ResponseFromJSONTyped = exports.GetVouchersCount200ResponseFromJSON = exports.instanceOfGetVouchersCount200Response = void 0;
var GetVouchersCount200ResponseData_1 = require("./GetVouchersCount200ResponseData");
/**
 * Check if a given object implements the GetVouchersCount200Response interface.
 */
function instanceOfGetVouchersCount200Response(value) {
    var isInstance = true;
    isInstance = isInstance && "data" in value;
    return isInstance;
}
exports.instanceOfGetVouchersCount200Response = instanceOfGetVouchersCount200Response;
function GetVouchersCount200ResponseFromJSON(json) {
    return GetVouchersCount200ResponseFromJSONTyped(json, false);
}
exports.GetVouchersCount200ResponseFromJSON = GetVouchersCount200ResponseFromJSON;
function GetVouchersCount200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': (0, GetVouchersCount200ResponseData_1.GetVouchersCount200ResponseDataFromJSON)(json['data']),
    };
}
exports.GetVouchersCount200ResponseFromJSONTyped = GetVouchersCount200ResponseFromJSONTyped;
function GetVouchersCount200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': (0, GetVouchersCount200ResponseData_1.GetVouchersCount200ResponseDataToJSON)(value.data),
    };
}
exports.GetVouchersCount200ResponseToJSON = GetVouchersCount200ResponseToJSON;
